module.exports = __webpack_public_path__ + "static/img/wx.cff04f62.svg";